import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/common/helpers/api-helper';
import HoursRegistrationApi from '@infrastructure/hours-registration-api';
import { addSuccessNotification } from '../common/notificationSlice';
import { translate } from '@application/common/helpers/translate';
export const getWeekDaysByMonthYearWeekNoAndAssignmentIdAsync = createAsyncThunk('hoursRegistration/getWeekDaysByMonthYearWeekNoAndAssignmentId', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await HoursRegistrationApi.getDaysByMonthYearWeekNoAndAssignmentId(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getHoursByTimeSheetIds = createAsyncThunk('hoursRegistration/GetHoursByTimeSheetId', async (timeSheetId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await HoursRegistrationApi.getHoursByTimeSheetIdsForAdmin(timeSheetId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const updateTimeSheetAndHourRegistrationStatus = createAsyncThunk('hoursRegistration/UpdateTimeSheetAndHourRegistrationStatus', async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await HoursRegistrationApi.updateTimeSheetAndHourRegistrationStatus(request);
        dispatch(addSuccessNotification(translate('hoursRegistration.hoursUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const registerHoursPerDayAsync = createAsyncThunk('hoursRegistration/registerPerDay', async (hoursLogged, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await HoursRegistrationApi.registerHoursPerDay(hoursLogged);
        dispatch(addSuccessNotification(translate('hoursRegistration.hoursUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const bulkRegisterHoursAsync = createAsyncThunk('hoursRegistration/BulkRegister', async (hoursLogged, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await HoursRegistrationApi.bulkRegisterHours(hoursLogged.hoursLogged, hoursLogged.expectedWeekVersion);
        dispatch(addSuccessNotification(translate('hoursRegistration.hoursAddedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getLoggedHoursPerDayByIdAsync = createAsyncThunk('hoursRegistration/getLoggedHoursById', async (Id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await HoursRegistrationApi.getLoggedHoursPerDayById(Id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getMonthListByAssignmentAndFreelancerId = createAsyncThunk('hoursRegistration/GetMonthListByAssignmentAndFreelancerId', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await HoursRegistrationApi.GetMonthListByAssignmentAndFreelancerId(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getYearListByAssignmentAndFreelancerId = createAsyncThunk('hoursRegistration/GetYearListByAssignmentAndFreelancerId', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await HoursRegistrationApi.getYearListByAssignmentAndFreelancerId(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const reSyncBusinessCentralHoursByTimeSheetIdsAsync = createAsyncThunk('hoursRegistration/reSyncBusinessCentralHoursByTimeSheetIds', async (timeSheetId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await HoursRegistrationApi.reSyncBusinessCentralHoursByTimeSheetIds(timeSheetId);
        dispatch(addSuccessNotification(translate('add message here')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
